import React from 'react';

function NoLaborder() {
	return (
		<div className="practiceManagementForm" style={{ border: '1px solid #dadada' }}>
			<div className="noDataFound">
				<p>No Lab Order Found</p>
			</div>
		</div>
	);
}
export default NoLaborder;
